import WhyOta from './WhyOta'

export default WhyOta
